import React, { useState, useEffect } from "react";
import { useWatch, useForm } from "react-hook-form";
import axios from "axios";
import Modal from "react-bootstrap/Modal";
import SearchableSelect from "../Master/searchableSelect";
import ButtonComp from "../../_helpers/Button";
import { ButtonLoader } from "../Loader";
import { addRec, downLoadFile, fetchListing } from "../../services";
import Select from 'react-select';
import { errorToast, filterActiveData, successToast } from "../../_helpers/utilities";
import { isCompositeComponent } from "react-dom/test-utils";

const SelectDIBModal = ({
  openDIBModalFunc,
  openDIBModal,
  closeDIBModal,
  ResponseData,
  labelVal = "DIB",
  disabled = false,
  GetData = true,
  from
}) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
    getValues,
    control,
    reset,
    clearErrors,
    watch,
    setError,
    ...rest
  } = useForm({
    defaultValues: {
      FinalTable: [],
      paramMainGroup1: "",
      paramMainGroup2: "",
      paramMainGroup3: "",
      rpm: "",
      gearBox: "",
      gearbox_additional: "",
      gearbox_europrice: "",
      breakSize: "",
      hrhf: "",
      hrPosition: "",
      tf: "",
      vFan: "",
      rs: "",
      specialLubricant: "",
      motorSideOilSeal: "",
      ip: "",
      motor_optional: "",
      motor_europrice: "",
      tbCableEntry: "",
      brakeVoltage: "",
      break_rectifier: "",
      output_shaft: "",
      output_flange: "",
      mtg_position: "",
      special_instruction: "",
      responseData: [],
      breakTorque: "",
      twoW: "",
      c: "",
      plant: "",
      qty: "",

    }
  });

  const FinalTableArray = useWatch({
    control,
    name: "FinalTable",
  });

  const ResponseDataVal = useWatch({
    control,
    name: "responseData",
  });

  const ParamMainGroup3Val = useWatch({
    control,
    name: "paramMainGroup3",
  });

  const BrakeVoltageVal = useWatch({
    control,
    name: "brakeVoltage",
  });

  const BreakSizeVal = useWatch({
    control,
    name: "breakSize",
  });

  const HrhfVal = useWatch({
    control,
    name: "hrhf",
  });


  const [loading, setLoading] = useState([]);
  const [plantArr, setPlantArr] = useState([]);
  const [configureTag, setConfigureTag] = useState([]);
  const [selectedValues, setSelectedValues] = useState([]);
  const [viewForm, setViewForm] = useState(true);
  const [selectOptions, setSelectOptions] = useState({
    brakeMotorWithoutBrake: [],
    paramMainGroup1: [],
    paramMainGroup2: [],
    paramMainGroup3: [],
    rpm: [],
    gearBox: [],
    breakSize: [],
    hrhf: [],
    hrPosition: [],
    tf: [],
    vFan: [],
    rs: [],
    specialLubricant: [],
    motorSideOilSeal: [],
    ip: [],
    tbCableEntry: [],
    brakeVoltage: [],
    breakTorque: [],
    break_rectifier: [],
    twoW: [],
    c: [],
    s4Duty: []
  });
  const [selectOptionsLoader, setSelectOptionsLoader] = useState({
    brakeMotorWithoutBrake: false,
    paramMainGroup1: false,
    paramMainGroup2: false,
    paramMainGroup3: false,
    rpm: false,
    gearBox: false,
    breakSize: false,
    hrhf: false,
    hrPosition: false,
    tf: false,
    vFan: false,
    rs: false,
    specialLubricant: false,
    motorSideOilSeal: false,
    ip: false,
    tbCableEntry: false,
    brakeVoltage: false,
    breakTorque: false,
    break_rectifier: false,
    twoW: false,
    c: false,
  });

  useEffect(() => {
    if (openDIBModal) {
      GrpTwoList()
      GrpOneList()
      TBCableEntryList()
      HRPositionList()
      configureDIBTag()
      if (from === "Topbar") {
        plantList();
      }
    } else {
      reset()
    }
  }, [openDIBModal]);

  const OptionData = (key, data) => {
    setSelectOptions(old => ({
      ...old,
      [key]: data,
    }))
  }
  const OptionDataLoader = (key, data) => {
    setSelectOptionsLoader(old => ({
      ...old,
      [key]: data,
    }))
  }

  const checkIfMatched = (selectedValues, configureTag) => {
    return selectedValues.some(selected => {
      return configureTag.some(tag => {
        const selectedFieldName = selected.fieldName.trim().toLowerCase();
        const selectedValue = String(selected.value).trim().toLowerCase();
        const tagKey = tag.key.trim().toLowerCase();
        // const tagKey = tag.key.trim().toLowerCase().replace(" ", "")
        const tagValue = String(tag.value).trim().toLowerCase();

        return selectedFieldName === tagKey && selectedValue === tagValue;
      });
    });
  };

  const handleUpdateArray = () => {
    const formValues = watch();
    const updatedArray = Object.entries(formValues)?.map(([key, value]) => ({
      fieldName: key,
      value: value,
    }));
    setSelectedValues(updatedArray);
  };

  const plantList = async () => {
    let data = await fetchListing("/MasterPlant/getalls");
    if (data?.status === 200) {
      if (data?.data?.length > 0) {
        let addName = data?.data.map((item) => {
          let sapcode = item?.sapCode ? " (" + item?.sapCode + ")" : "";
          return { ...item, name: item.name + sapcode, id: item.name };
        });
        setPlantArr(filterActiveData(addName));

      } else {
        setPlantArr([]);

      }
    }
  };

  const configureDIBTag = async () => {
    let data = await fetchListing("/ConfigureDIBTag/getalls");
    if (data?.status === 200) {
      setConfigureTag(data?.data);
    }
  };

  const GrpOneList = async () => {
    OptionDataLoader("paramMainGroup1", true)
    let data = await fetchListing("/DIBOR/GetMainGroup1");
    if (data?.status === 200) {
      let Result = data.data.map((item) => ({
        ...item,
        name: item.typeR,
        price: item.price1,
      }))
      OptionData("paramMainGroup1", Result)
      OptionDataLoader("paramMainGroup1", false)
    } else {
      OptionData("paramMainGroup1", [])
      OptionDataLoader("paramMainGroup1", false)
    }
  };

  const ListingAPI = () => {
    RPMList()
    BreakSizeList()
    TFList()
    VFanList()
    RSList()
    SpecialLubricantList()
    MotorSideOilSealList()
    IPList()
    BrakeVoltageList()
    BreakTorqueList()
    TwoWList()
    C_List()
    BrakeMotorWithoutBrakeList()
  }

  const Get_DUty = async () => {
    let paramMainGroup3 = getValues("paramMainGroup3");
    let data = await fetchListing(`/DIBS4Duty/GetS4DutyByMainGroup3/${paramMainGroup3}`);
    if (data?.status === 200) {
      let Result = data.data.map((item) => ({
        ...item,
        name: item.dutyType,
        id: item.dutyType,
      }))
      setValue("s4Duty", Result[0]?.id)
      OptionData("s4Duty", Result)
    } else {
      OptionData("s4Duty", [])
    }
  };

  const GrpTwoList = async () => {
    let data = await fetchListing("/DIBOR/GetMainGroup2");
    if (data?.status === 200) {
      let Result = data.data.map((item) => ({
        ...item,
        name: item.mainGroup2Value,
        id: item.mainGroup2Value,
      }))
      OptionData("paramMainGroup2", Result)
    } else {
      OptionData("paramMainGroup2", [])
    }
  };

  const GrpThreeList = async () => {

    let paramMainGroup1 = getValues("paramMainGroup1");
    let paramMainGroup2 = getValues("paramMainGroup2");
    let url = "";
    if (paramMainGroup2) {
      url = `?MainGroup2=${paramMainGroup2}`;
    }
    let data = await fetchListing(`/DIBMotorData/GetMainGroup3/${paramMainGroup1}${url}`);
    if (data?.status === 200) {
      let Result = data.data.map((item) => ({
        ...item,
        name: item.motorType,
        id: item.motorId,
      }))
      OptionData("paramMainGroup3", Result)
    } else {
      OptionData("paramMainGroup3", [])
    }
  };

  const RPMList = async () => {
    let paramMainGroup1 = getValues("paramMainGroup1");
    let paramMainGroup2 = getValues("paramMainGroup2");
    let paramMainGroup3 = getValues("paramMainGroup3");

    let url = "";
    if (paramMainGroup2) {
      url = `?MainGroup2=${paramMainGroup2}`;
    }

    let data = await fetchListing(`/DIBR/GetRPM/${paramMainGroup1}/${paramMainGroup3}${url}`);
    if (data?.status === 200) {
      let Result = data.data.map((item) => ({
        ...item,
        name: item.dibsna.toFixed(2),
        id: item.rId,
      }))

      OptionData("rpm", Result)

    } else {
      OptionData("rpm", [])

    }
  };

  const GearBoxList = async () => {
    let paramMainGroup1 = getValues("paramMainGroup1");


    let data = await fetchListing(`/DIBOR/GetGearBox/${paramMainGroup1}`);
    if (data?.status === 200) {
      let Result = data.data.map((item) => ({
        ...item,
        name: item.specialityGB,
        price: item.price2
      }))
      OptionData("gearBox", Result)
    } else {
      OptionData("gearBox", [])
    }
  };

  const BreakSizeList = async () => {
    let paramMainGroup3 = getValues("paramMainGroup3");

    let data = await fetchListing(`/DIBMO/GetBreakSize/${paramMainGroup3}`);
    if (data?.status === 200) {
      let Result = data.data.map((item) => ({
        ...item,
        name: item.brakeSize,
        price: item.brakePrice
      }))
      OptionData("breakSize", Result)
    } else {
      OptionData("breakSize", [])
    }
  };

  const HRHFList = async () => {
    let paramMainGroup3 = getValues("paramMainGroup3");
    let breakSize = getValues("breakSize");
    if (breakSize && paramMainGroup3) {
      let data = await fetchListing(`/DIBMO/GetHRHFPriceByMainGroup3IdAndBreakSizeId/${paramMainGroup3}/${breakSize}`);
      if (data?.status === 200) {
        let Result = data.data.map((item) => ({
          ...item,
          name: item.hrhfValue,
          id: item.hrhfValue,
          price: item.hrhfPrice
        }))
        OptionData("hrhf", Result)
      } else {
        OptionData("hrhf", [])
      }
    } else {
      OptionData("hrhf", [])
    }
  };

  const HRPositionList = async () => {
    let data = await fetchListing("/DIBMO/GetHRPosition");
    if (data?.status === 200) {
      let Result = data.data.map((item) => ({
        ...item,
        name: item.hrPositionValue,
        id: item.hrPositionValue,
      }))
      OptionData("hrPosition", Result)
    } else {
      OptionData("hrPosition", [])
    }
  };

  const TFList = async () => {
    let paramMainGroup3 = getValues("paramMainGroup3");

    let data = await fetchListing(`/DIBMO/GetTFPriceByMainGroup3Id/${paramMainGroup3}`);
    if (data?.status === 200) {
      let Result = data.data.map((item) => ({
        ...item,
        name: item.tfValue,
        id: item.tfValue,
        price: item.tfPrice
      }))
      OptionData("tf", Result)
    } else {
      OptionData("tf", [])
    }
  };

  const VFanList = async () => {
    let paramMainGroup3 = getValues("paramMainGroup3");

    let data = await fetchListing(`/DIBMO/GetVfanPriceByMainGroup3Id/${paramMainGroup3}`);
    if (data?.status === 200) {
      let Result = data.data.map((item) => {
        return ({
          ...item,
          isDisabled: item?.vFanPrice ? false : true,
          name: item?.vfanValue,
          id: item.vfanValue,
          price: item.vFanPrice
        })
      })
      OptionData("vFan", Result)
    } else {
      OptionData("vFan", [])
    }
  };

  const RSList = async () => {
    let paramMainGroup3 = getValues("paramMainGroup3");

    let data = await fetchListing(`/DIBMO/GetRSPriceByMainGroup3Id/${paramMainGroup3}`);
    if (data?.status === 200) {
      let Result = data.data.map((item) => {
        return ({
          ...item,
          isDisabled: item.rsPrice ? false : true,
          name: item?.rsValue,
          id: item.rsValue,
          price: item.rsPrice
        })
      })
      OptionData("rs", Result)
    } else {
      OptionData("rs", [])
    }
  };

  const SpecialLubricantList = async () => {
    let paramMainGroup3 = getValues("paramMainGroup3");

    let data = await fetchListing(`/DIBMO/GetSpecialLubricantPriceByMainGroup3Id/${paramMainGroup3}`);
    if (data?.status === 200) {
      let Result = data.data.map((item) => ({
        ...item,
        name: item.spLubricantValue,
        id: item.spLubricantValue,
        motorSideOilSealValue: item.motorSideOilSealValue,
        price: item.fkmPrice,
        calculatePrice: item.calculatePrice
      }))

      OptionData("specialLubricant", Result)
      setValue("specialLubricant", Result[0].id)
      let motorSideOilSeal = "";
      let isCalculate = false;
      if (Result[0]?.calculatePrice) isCalculate = true;
      if (Result[0]?.motorSideOilSealValue) motorSideOilSeal = Result[0]?.motorSideOilSealValue;
      setValue("motorSideOilSeal", motorSideOilSeal)

    } else {
      OptionData("specialLubricant", [])
    }
  };

  const MotorSideOilSealList = async () => {
    let data = await fetchListing("/DIBMO/GetMotorSideOilSeal");
    if (data?.status === 200) {
      let Result = data.data.map((item) => ({
        ...item,
        name: item.motorSideOilSealValue,
        id: item.motorSideOilSealValue,
      }))
      OptionData("motorSideOilSeal", Result)
    } else {
      OptionData("motorSideOilSeal", [])
    }
  };

  const IPList = async () => {
    let paramMainGroup3 = getValues("paramMainGroup3");
    let data = await fetchListing(`/DIBMO/GetIPPriceByMainGroup3Id/${paramMainGroup3}`);
    if (data?.status === 200) {
      let Result = data.data.map((item) => ({
        ...item,
        name: item.ipValue,
        id: item.ipValue,
        calculatePrice: item.calculatePrice,
        price: item.ipPrice
      }))
      OptionData("ip", Result)
    } else {
      OptionData("ip", [])
    }
  };
  const BreakTorqueList = async () => {
    let paramMainGroup3 = getValues("paramMainGroup3");
    let data = await fetchListing(`/DIBMotorData/GetBrakeTorque/${paramMainGroup3}`);
    if (data?.status === 200) {
      let Result = data.data.filter(item => item.brakeTorqueValue !== null).map((item) => ({
        ...item,
        name: item.brakeTorqueValue,
        id: item.brakeTorqueValue.toString(),
        mainId: item.id,
      }))
      OptionData("breakTorque", Result)
    } else {
      OptionData("breakTorque", [])
    }
  };
  const TwoWList = async () => {
    let paramMainGroup3 = getValues("paramMainGroup3");
    let data = await fetchListing(`/DIBMO/GetTwoWPriceByMainGroup3Id/${paramMainGroup3}`);
    if (data?.status === 200) {
      let Result = data.data.map((item) => ({
        ...item,
        name: item.twoWValue,
        id: item.twoWValue,
        price: item.twoWPrice
      }))
      OptionData("twoW", Result)
    } else {
      OptionData("twoW", [])
    }
  };
  const C_List = async () => {
    let paramMainGroup3 = getValues("paramMainGroup3");
    let data = await fetchListing(`/DIBMO/GetCPriceByMainGroup3Id/${paramMainGroup3}`);
    if (data?.status === 200) {
      let Result = data.data.map((item) => ({
        ...item,
        name: item.cValue,
        id: item.cValue,
        price: item.cPrice
      }))
      OptionData("c", Result)
    } else {
      OptionData("c", [])
    }
  };

  useEffect(() => {
    if (BrakeVoltageVal) {
      BrakeRectifierList()
    } else {
      setValue("break_rectifier", "")
      OptionData("break_rectifier", [])
    }
  }, [BrakeVoltageVal])


  useEffect(() => {
    clearErrors("brakeVoltage")
    clearErrors("breakTorque")
    clearErrors("break_rectifier")

    // setValue("brakeVoltage", "")
    // setValue("breakTorque", "")
    setValue("break_rectifier", "")
    OptionData("break_rectifier", [])
    if (!BreakSizeVal) {
      setValue("brakeVoltage", "")
      setValue("breakTorque", "")
    }

  }, [BreakSizeVal])



  const BrakeRectifierList = async () => {
    let paramMainGroup3 = getValues("paramMainGroup3");
    let data = await fetchListing(`/DIBMotorData/GetBrakeRectifier/${paramMainGroup3}/${BrakeVoltageVal}`);
    if (data?.status === 200) {
      let Result = data.data.map((item) => ({
        ...item,
        name: item.brakeRectifierValue,
        id: item.brakeRectifierValue,
        mainId: item.id,
        // price: item.cPrice
      }))
      OptionData("break_rectifier", Result)
    } else {
      OptionData("break_rectifier", [])

    }
  };

  const TBCableEntryList = async () => {
    let data = await fetchListing("/DIBMotorData/GetTBCableEntry");
    if (data?.status === 200) {
      let Result = data.data.map((item) => ({
        ...item,
        name: item.tbCableEntryValue,
        id: item.tbCableEntryValue,
      }))
      OptionData("tbCableEntry", Result)
      setValue("tbCableEntry", Result[0].id)
    } else {
      OptionData("tbCableEntry", [])
    }
  };

  const BrakeVoltageList = async () => {
    let paramMainGroup3 = getValues("paramMainGroup3");
    let data = await fetchListing(`/DIBMotorData/GetBrakeVoltageByMainGroup3Id/${paramMainGroup3}`);
    if (data?.status === 200) {
      let Result = data.data.map((item) => ({
        ...item,
        name: item.brakeVoltageValue,
        breakRectifier: item.breakRectifier
      }))
      OptionData("brakeVoltage", Result)
    } else {
      OptionData("brakeVoltage", [])
    }
  };

  const BrakeMotorWithoutBrakeList = async () => {
    let MainGroup3Id = getValues("paramMainGroup3");
    let data = await fetchListing(`/DIBMotorPrice/GetBrakeMotorWithoutBrakeByMainGroup3Id/${MainGroup3Id}`);
    if (data?.status === 200) {
      console.log("🚀 ~ Result ~ data.data:", data.data)
      let Result = data.data.map((item) => ({
        ...item,
        id: item.value.replace('/', '').toLowerCase(),
        name: item.value,
        price: item.price
      }))
      OptionData("brakeMotorWithoutBrake", Result)
    } else {
      OptionData("brakeMotorWithoutBrake", [])
    }
  };

  const [HRHFDisable, setHRHFDisable] = useState(false);
  const [hrPositionsDisable, setHRPositionDisable] = useState(true);
  const [vFanDisable, setVFanDisable] = useState(false);
  const [rsDisable, setRSDisable] = useState(true);
  const [breakSizeDisable, setBreakSizeDisable] = useState(true);
  const [breakMotorWithOutBreak, setBreakMotorWithOutBreak] = useState(false);

  const UpdateFinalTable = (key, e, index, option) => {

    if (e.target.value) {
      let OldRecord = getValues("FinalTable")
      if (option?.length > 0) {
        let findObj = option?.find((item) => item.id === e.target.value)
        let NewName = key + " " + (findObj?.name ? findObj?.name : "")
        let price = findObj?.price ? parseFloat(findObj?.price) : 0

        if (OldRecord?.length > 0) {
          let findRec = OldRecord.find((item) => item.index === index)
          let findIndex = OldRecord.findIndex((item) => item.index === index)
          if (findRec) {
            let asd = ({
              ...findRec,
              name: NewName,
              price: price.toFixed(2),
              item: findObj,
              key: e.target.name
            })

            OldRecord.splice(findIndex, 1, asd);
            setValue("FinalTable", OldRecord)
          } else {
            let asd = ({
              ...findRec,
              name: NewName,
              price: price.toFixed(2),
              item: findObj,
              index: index,
              key: e.target.name
            })
            OldRecord.push(asd)
            setValue("FinalTable", OldRecord)
          }
        } else {
          let rec = [{
            name: NewName,
            price: price.toFixed(2),
            item: findObj,
            index: index,
            key: e.target.name
          }]
          setValue("FinalTable", rec)
        }
      } else {
        let price = parseFloat(e.target.value)
        if (OldRecord?.length > 0) {
          let findRec = OldRecord.find((item) => item.index === index)
          let findIndex = OldRecord.findIndex((item) => item.index === index)
          if (findRec) {
            let asd = ({
              ...findRec,
              name: key,
              price: price.toFixed(2),
              item: {},
              key: e.target.name
            })

            OldRecord.splice(findIndex, 1, asd);
            setValue("FinalTable", OldRecord)

          } else {
            let asd = ({
              ...findRec,
              name: key,
              price: price.toFixed(2),
              item: {},
              index: index,
              key: e.target.name
            })
            OldRecord.push(asd)
            setValue("FinalTable", OldRecord)
          }
        } else {
          let rec = [{
            name: key,
            price: price.toFixed(2),
            item: {},
            index: index,
            key: e.target.name
          }]
          setValue("FinalTable", rec)
        }
      }
    }
  }

  const ReSetGRP1 = () => {
    setValue("paramMainGroup2", "")
    setValue("gearbox_additional", "")
    setValue("gearbox_europrice", "")
    setValue("motor_optional", "")
    setValue("motor_europrice", "")
    //setValue("tbCableEntry", "")
    setValue("brakeVoltage", "")
    setValue("break_rectifier", "")
    setValue("special_instruction", "")
    setValue("breakTorque", "")
    setValue("brakeMotorWithoutBrake", "")
    ReSetGRP3()
  }

  const ReSetGRP3 = () => {
    setValue("rpm", "")
    setValue("rs", "")
    setValue("gearBox", "")
    setValue("breakSize", "")
    setValue("hrPosition", "")
    setValue("hrhf", "")
    setValue("tf", "")
    setValue("vFan", "")
    //setValue("specialLubricant", "")
    setValue("ip", "")
    setValue("motorSideOilSeal", "")
    setValue("twoW", "")
    setValue("c", "")
    setValue("brakeMotorWithoutBrake", "")
  }

  const RemoveFinalTable = (key, e) => {
    let IsNull = e.target.value === null ? true : false
    let InputVal = e.target.value
    let isCalculate = false;
    let OldRecord = getValues("FinalTable")
    let filterKey = []

    if (key === "paramMainGroup1") {

      if (IsNull) {
        filterKey = ["paramMainGroup1", "paramMainGroup3", "rpm", "gearBox", "gearbox_europrice", "motor_europrice", "breakSize", "rs", "hrhf", "tf", "vFan", "specialLubricant", "ip", "twoW", "c", "brakeMotorWithoutBrake"]
        setValue("paramMainGroup1", "")
        setValue("output_shaft", "")
        setValue("output_flange", "")
        setValue("mtg_position", "")
        setBreakSizeDisable(false)
        setRSDisable(false);
        ReSetGRP1()
      } else {
        filterKey = ["paramMainGroup3", "rpm", "gearBox", "gearbox_europrice", "motor_europrice", "breakSize", "rs", "hrhf", "tf", "vFan", "specialLubricant", "ip", "twoW", "c", "brakeMotorWithoutBrake"]
        let findObj = selectOptions?.paramMainGroup1?.find((item) => item.id === e.target.value)
        setValue("output_shaft", findObj?.shaft)
        setValue("output_flange", findObj?.flange)
        setValue("mtg_position", findObj?.mountingPosition)
        ReSetGRP1()
      }
    } else if (key === "rpm") {
      if (IsNull) {
        filterKey = ["rpm"]
        setValue("rpm", "")
      }
    } else if (key === "paramMainGroup3") {

      filterKey = ["rpm", "gearBox", "breakSize", "rs", "hrhf", "tf", "vFan", "specialLubricant", "ip", "twoW", "c", "brakeMotorWithoutBrake"]

      if (IsNull) {
        ReSetGRP3()
      } else {
        ReSetGRP3()
      }

    } else if (key === "gearBox") {
      if (IsNull) {

        filterKey = ["gearBox"]
        setValue("gearBox", "")
      } else {

      }
    } else if (key === "brakeMotorWithoutBrake") {
      if (IsNull) {

        filterKey = ["brakeMotorWithoutBrake"]
        setValue("brakeMotorWithoutBrake", "")
      } else {
        filterKey = ["breakSize"]
      }
    } else if (key === "breakSize") {
      if (IsNull) {
        filterKey = ["breakSize", "hrhf",]

        setValue("breakSize", "")
        setValue("hrhf", "")
        setValue("hrPosition", "")
        setValue("vFan", "")
        setValue("rs", "")

        clearErrors("hrPosition", "")

        setHRHFDisable(true)
        setHRPositionDisable(true)
        setVFanDisable(false)
        setRSDisable(false)
      } else {
        filterKey = ["hrhf", "vFan"]

        setValue("hrhf", "")
        setValue("hrPosition", "")
        setValue("vFan", "")
        setValue("rs", "")

        setVFanDisable(true)
        setRSDisable(true)
        setHRHFDisable(false)
        setHRPositionDisable(false)
      }
    } else if (key === "hrhf") {
      if (IsNull) {
        filterKey = ["hrhf"]
        setValue("hrhf", "")
      } else {

      }
    } else if (key === "tf") {
      if (IsNull) {
        filterKey = ["tf"]
        setValue("tf", "")
      } else {

      }
    } else if (key === "hrPosition") {
      if (IsNull) {
        filterKey = ["hrPosition"]
        setValue("hrPosition", "")
      } else {

      }
    } else if (key === "vFan") {
      if (IsNull) {
        filterKey = ["vFan"]
        setValue("vFan", "")
        setBreakSizeDisable(false)
        setRSDisable(false)
      } else {
        setHRHFDisable(true)
        setHRPositionDisable(true)
        setBreakSizeDisable(true)
        setRSDisable(true)
      }
    } else if (key === "rs") {
      if (IsNull) {
        filterKey = ["rs"]
        setValue("rs", "")
        setHRHFDisable(false)
        setHRPositionDisable(false)
        setBreakSizeDisable(false)
        setVFanDisable(false)
      } else {
        setHRHFDisable(true)
        setHRPositionDisable(true)
        setBreakSizeDisable(true)
        setVFanDisable(true)
      }
    } else if (key === "specialLubricant") {


      let motorSideOilSeal = "";
      let findVal = selectOptions.specialLubricant?.find((obj) => obj.id === InputVal)
      if (findVal) {
        if (findVal?.calculatePrice) isCalculate = true;
        if (findVal?.motorSideOilSealValue) motorSideOilSeal = findVal?.motorSideOilSealValue;
      }
      if (IsNull) {
        filterKey = ["specialLubricant"]
        setValue("specialLubricant", "")
        setValue("motorSideOilSeal", "")
      } else {
        if (!isCalculate) filterKey = ["specialLubricant"]
        setValue("motorSideOilSeal", motorSideOilSeal)
      }

    } else if (key === "ip") {
      let findVal = selectOptions.ip?.find((obj) => obj.id === InputVal)
      if (findVal) {
        if (findVal?.calculatePrice) isCalculate = true;
      }
      if (IsNull) {
        filterKey = ["ip"]
        setValue("ip", "")
      } else if (!isCalculate) {
        filterKey = ["ip"]

      } else {
        filterKey = ["vFan"]
      }
    } else if (key === "brakeVoltage") {
      let breakRectifier = "";
      let findVal = selectOptions.brakeVoltage?.find((obj) => obj.id === InputVal)
      if (findVal) {
        if (findVal?.breakRectifier) breakRectifier = findVal?.breakRectifier;
      }
      if (IsNull) {
        filterKey = []
        setValue("brakeVoltage", "")
        setValue("break_rectifier", "")
        setValue("breakTorque", "")
      } else {
        setValue("break_rectifier", "")
        setValue("breakTorque", "")
      }
    } else if (key === "motor_europrice") {
      if (!e.target.value) {
        filterKey = ["motor_europrice"]
        setValue("motor_europrice", "")
      }
    } else if (key === "gearbox_europrice") {
      if (!e.target.value) {
        filterKey = ["gearbox_europrice"]
        setValue("gearbox_europrice", "")
      }
    } else if (key === "twoW") {
      if (!e.target.value) {
        filterKey = ["twoW"]
        setValue("twoW", "")
      }
    } else if (key === "c") {
      if (!e.target.value) {
        filterKey = ["c"]
        setValue("c", "")
      }
    }

    let res = OldRecord.filter(item => !filterKey.includes(item.key));
    setValue("FinalTable", res)
  }

  const FieldCheck = (IsView) => {

    let isValid = true;
    if (!IsView) {
      let PlantVal = getValues("plant")
      let QTYVal = getValues("qty")
      if (PlantVal === "" || PlantVal === null) {
        setError("plant", "Required")
        isValid = false
      }
      if (QTYVal === "" || QTYVal === null) {
        setError("qty", "Required")
        isValid = false
      }
    }
    return isValid;
  }

  const onSubmit = async (data, IsView) => {
    let plant = plantArr.find((item) => item.id == data.plant)?.sapCode
    data.plant = plant ? plant : ""
    if (FieldCheck(IsView)) {
      let total = data?.FinalTable?.reduce((acc, value) => {
        return (acc = acc + parseFloat(value.price));
      }, 0).toFixed(2);

      delete data?.FinalTable
      delete data?.responseData
      data.hrPosition = data.hrPosition.toString()
      // data.qty = 1;
      if (data.qty) data.qty = parseInt(data.qty)
      data.gearBox = parseInt(data.gearBox)
      data.breakSize = parseInt(data.breakSize)
      data.brakeVoltage = parseInt(data.brakeVoltage)

      data.total = total;
      if (IsView) {
        setLoading([1])
        let result = await addRec("/DIBR/DIBViewDetails", data);
        if (result?.status === 200) {
          if (result?.data?.length > 0) {
            setValue("responseData", result?.data)
            setViewForm(false)
          } else {
            setValue("responseData", [])
          }
        } else {
          setValue("responseData", [])
        }
        setLoading([])
      } else {
        setLoading([2])
        let response = await downLoadFile(`${process.env.REACT_APP_API_URL}/DIBLauffMaster/GetPartList`, data)

        if (response?.data?.byteLength > 500) {
          const url = window.URL.createObjectURL(new Blob([response?.data]));
          const link = document.createElement('a');
          link.href = url;
          //const filename =  response.headers.get('Content-Disposition').split('filename=')[1];
          let Group1 = selectOptions?.paramMainGroup1?.find((item) => item.id === data.paramMainGroup1)?.name
          let Group2 = selectOptions?.paramMainGroup2?.find((item) => item.id === data.paramMainGroup2)?.name
          let Group3 = selectOptions?.paramMainGroup3?.find((item) => item.id === data.paramMainGroup3)?.name
          Group1 = Group1 ? Group1 : ""
          Group2 = Group2 ? Group2 : ""
          Group3 = Group3 ? Group3 : ""
          const filename = `Config-${Group1} ${Group2} ${Group3}`;
          link.setAttribute("download", filename + '.xlsx'); //or any other extension
          document.body.appendChild(link);
          link.click();
        } else {
          errorToast("NO COMBINATION SELECTED")
        }
        setLoading([])
      }
    }
  };

  return (
    <>
      <Modal size="lg" show={openDIBModal} onHide={() => closeDIBModal()}>
        <Modal.Header closeButton>
          <Modal.Title>DIB   {viewForm ? " Selection" : " Details"}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {viewForm ?
            <div className="comanbox_body">
              <div className="row g-3 mx-0">
                <div className="col-md-8 DIBModel">
                  <div className="row">
                    <div class="col-md-4">
                      <div class="inputcu-field">
                        <label className="cu_form_label">Main Group 1 :</label>


                        <SearchableSelect
                          placeholder=""
                          name="paramMainGroup1"
                          optionList={selectOptions.paramMainGroup1}
                          OptionLoading={selectOptionsLoader.paramMainGroup1}
                          errors={errors.paramMainGroup1}
                          control={control}
                          {...register("paramMainGroup1", {
                            onChange: (e) => {
                              UpdateFinalTable("Main Group 1 :", e, 0, selectOptions.paramMainGroup1)
                              RemoveFinalTable("paramMainGroup1", e)
                              GrpThreeList()
                              GearBoxList()
                              setValue("s4Duty", "")
                            },
                            required: "Fill Main Group 1",
                          })}
                        />
                      </div>
                    </div>
                    <div class="col-md-4">
                      <div class="inputcu-field">
                        <label className="cu_form_label">Main Group 2 :</label>
                        <SearchableSelect
                          placeholder=""
                          name="paramMainGroup2"
                          optionList={selectOptions.paramMainGroup2}
                          OptionLoading={selectOptionsLoader.paramMainGroup1}
                          errors={errors.paramMainGroup2}
                          control={control}
                          {...register("paramMainGroup2", {
                            onChange: (e) => {
                              GrpThreeList()
                            }
                            // required: "Container Number is required.",
                          })}
                        />
                      </div>
                    </div>
                    <div class="col-md-4">
                      <div class="inputcu-field">
                        <label className="cu_form_label">Main Group 3 :</label>
                        <SearchableSelect
                          placeholder=""
                          name="paramMainGroup3"
                          optionList={selectOptions.paramMainGroup3}
                          OptionLoading={selectOptionsLoader.paramMainGroup1}
                          errors={errors.paramMainGroup3}
                          control={control}
                          {...register("paramMainGroup3", {
                            onChange: (e) => {
                              ListingAPI();
                              Get_DUty()
                              // UpdateFinalTable("Main Group 3 :", e, 0, selectOptions.paramMainGroup3)   
                              RemoveFinalTable("paramMainGroup3", e)
                              setValue("s4Duty", "")
                            }
                          })}
                        // {...register("paramMainGroup3", {
                        //   // required: "Container Number is required.",
                        // })}
                        />
                      </div>
                    </div>

                    <div class="col-md-4">
                      <div class="inputcu-field">
                        <label className="cu_form_label">RPM :</label>
                        <SearchableSelect
                          placeholder=""
                          name="rpm"
                          optionList={selectOptions.rpm}
                          errors={errors.rpm}
                          control={control}
                          {...register("rpm", {
                            onChange: (e) => {
                              if (e.target.value) {
                                UpdateFinalTable("RPM :", e, 1, selectOptions.rpm)
                                RemoveFinalTable("rpm", e)
                                setBreakMotorWithOutBreak(selectOptions.rpm.find((item) => item.id === e.target.value)?.brakeDisabled);
                                setBreakSizeDisable(selectOptions.rpm.find((item) => item.id === e.target.value)?.brakeDisabled);
                                setVFanDisable(selectOptions.rpm.find((item) => item.id === e.target.value)?.vDisabled);
                                setRSDisable(selectOptions.rpm.find((item) => item.id === e.target.value)?.rsDisabled);
                              } else {
                                setBreakSizeDisable(true);
                                setValue('breakSize', null);
                              }
                            },
                            required: "Fill RPM",
                          })}
                        />
                      </div>
                    </div>


                    <div class="col-md-8"></div>
                    <div className="line_box"></div>
                    <div class="col-md-4">
                      <div class="inputcu-field">
                        <label className="cu_form_label">
                          Gear Box(Optional) :
                        </label>
                        <SearchableSelect
                          placeholder=""
                          name="gearBox"
                          optionList={selectOptions.gearBox}
                          errors={errors.gearBox}
                          control={control}
                          {...register("gearBox", {
                            onChange: (e) => {
                              UpdateFinalTable("Gear Box :", e, 2, selectOptions.gearBox)
                              RemoveFinalTable("gearBox", e)
                            }
                            // required: "Container Number is required.",
                          })}
                        />
                      </div>
                    </div>
                    <div class="col-md-4">
                      <div class="input-group">
                        <label>Gear Box(Additional) :</label>
                        <input
                          type="text"
                          id="gearbox_additional"
                          name="gearbox_additional"
                          placeholder={
                            errors.gearbox_additional
                              ? errors.gearbox_additional.message
                              : ""
                          }
                          className={errors.gearbox_additional ? "error" : ""}
                          {...register("gearbox_additional", {
                            // required: "Note is required.",
                          })}
                        />
                      </div>
                    </div>
                    <div class="col-md-4">
                      <div class="input-group">
                        <label>G.Box Euro Price :</label>
                        <input
                          type="number"
                          min={0}
                          id="gearbox_europrice"
                          name="gearbox_europrice"
                          placeholder={errors.gearbox_europrice ? errors.gearbox_europrice.message : ""}
                          className={errors.gearbox_europrice ? "error" : ""}
                          {...register("gearbox_europrice", {
                            //valueAsNumber: true,
                            onBlur: (e) => {
                              UpdateFinalTable("Gear Box Additional ", e, 11, [])
                              RemoveFinalTable("gearbox_europrice", e)
                            }
                            // required: "Note is required.",
                          })}
                        />
                      </div>
                    </div>

                    <div className="col-lg-4">
                      <div class="inputcu-field">
                        <label className="cu_form_label">Brake Motor Without Brake :</label>
                        <SearchableSelect
                          placeholder=""
                          name="brakeMotorWithoutBrake"
                          optionList={selectOptions.brakeMotorWithoutBrake}
                          errors={errors.brakeMotorWithoutBrake}
                          control={control}
                          isDisabled={breakMotorWithOutBreak}
                          OptionLoading={false}
                          {...register("brakeMotorWithoutBrake", {
                            onChange: (e) => {
                              UpdateFinalTable("Brake Motor Without Brake :", e, 15, selectOptions.brakeMotorWithoutBrake)
                              RemoveFinalTable("brakeMotorWithoutBrake", e)
                              handleUpdateArray();
                              const selectedValue = e.target.value;
                              if (selectedValue === 'yes') {
                                setBreakSizeDisable(true);
                                setRSDisable(true);
                                setValue('breakSize', null);
                                setValue('rs', null);
                                setValue("s4Duty", selectOptions.s4Duty[0]?.id)
                              } else if (selectedValue === null) {
                                setBreakSizeDisable(true);
                                setRSDisable(true);
                                setValue('breakSize', null);
                                setValue('rs', null);
                              } else {
                                setBreakSizeDisable(false);
                                setRSDisable(false);
                              }
                            }
                          })}
                        />
                      </div>
                    </div>

                    <div class="col-md-4">
                      <div class="inputcu-field">
                        <label className="cu_form_label">Brake Size :</label>
                        <SearchableSelect
                          placeholder=""
                          name="breakSize"
                          optionList={selectOptions.breakSize}
                          errors={errors.breakSize}
                          control={control}
                          isDisabled={breakSizeDisable}
                          {...register("breakSize", {
                            onChange: (e) => {
                              HRHFList()
                              UpdateFinalTable("BreakSize :", e, 3, selectOptions.breakSize)
                              RemoveFinalTable("breakSize", e)
                              handleUpdateArray();
                              if (selectOptions?.brakeVoltage?.length > 0) {
                                setValue("brakeVoltage", selectOptions.brakeVoltage[0]?.id);
                              }
                              if (selectOptions?.breakTorque?.length > 0) {
                                setValue("breakTorque", selectOptions.breakTorque[0]?.id);
                              }
                            }
                            // required: "Container Number is required.",
                          })}
                        />
                      </div>
                    </div>





                    <div class="col-md-4">
                      <div class="inputcu-field">
                        <label className="cu_form_label">Duty :</label>
                        <SearchableSelect
                          placeholder=""
                          name="s4Duty"
                          optionList={selectOptions.s4Duty}
                          errors={errors.s4Duty}
                          control={control}
                          isDisabled={watch("breakSize") ? false : true}
                          {...register("s4Duty", {
                            required: "Fill S4 Duty",
                          })}
                        />
                      </div>
                    </div>










                    <div class="col-md-4">
                      <div class="inputcu-field">
                        <label className="cu_form_label">HR / HF :</label>
                        <SearchableSelect
                          placeholder=""
                          name="hrhf"
                          optionList={selectOptions.hrhf}
                          errors={errors.hrhf}
                          control={control}
                          isDisabled={HRHFDisable}
                          {...register("hrhf", {
                            onChange: (e) => {
                              UpdateFinalTable("HR/HF :", e, 4, selectOptions.hrhf)
                              RemoveFinalTable("hrhf", e)
                              clearErrors("hrPosition")
                              setValue("hrPosition", "")
                              handleUpdateArray();
                            },
                            // required: HrhfVal ? "Fill HR / HF" : false,
                          })}
                        />
                      </div>
                    </div>
                    <div class="col-md-4">
                      <div class="inputcu-field">
                        <label className="cu_form_label">HR Position :</label>
                        <SearchableSelect
                          placeholder=""
                          name="hrPosition"
                          optionList={selectOptions.hrPosition}
                          errors={errors.hrPosition}
                          control={control}
                          isDisabled={hrPositionsDisable}
                          {...register("hrPosition", {
                            onChange: (e) => {
                              // UpdateFinalTable("HR Position :", e, 5, selectOptions.hrPosition)
                              RemoveFinalTable("hrPosition", e)
                              handleUpdateArray();
                            },
                            required: HrhfVal ? "Fill HR Position" : false,
                          })}
                        />
                      </div>
                    </div>
                    <div class="col-md-4">
                      <div class="inputcu-field">
                        <label className="cu_form_label">TF :</label>
                        <SearchableSelect
                          placeholder=""
                          name="tf"
                          optionList={selectOptions.tf}
                          errors={errors.tf}
                          control={control}
                          {...register("tf", {
                            onChange: (e) => {
                              UpdateFinalTable("TF :", e, 5, selectOptions.tf)
                              RemoveFinalTable("tf", e)
                              handleUpdateArray();
                            }
                            // required: "Container Number is required.",
                          })}
                        />
                      </div>
                    </div>
                    <div class="col-md-4">
                      <div class="inputcu-field">
                        <label className="cu_form_label">V FAN :</label>
                        <SearchableSelect
                          placeholder=""
                          name="vFan"
                          optionList={selectOptions.vFan}
                          errors={errors.vFan}
                          control={control}
                          isDisabled={vFanDisable}
                          {...register("vFan", {
                            onChange: (e) => {
                              UpdateFinalTable("V Fan :", e, 6, selectOptions.vFan)
                              RemoveFinalTable("vFan", e)
                              handleUpdateArray();
                              if (e.target.value) {
                                setValue("ip", "");
                              }
                            }
                            // required: "Container Number is required.",
                          })}
                        />
                      </div>
                    </div>
                    <div class="col-md-4">
                      <div class="inputcu-field">
                        <label className="cu_form_label">RS :</label>
                        <SearchableSelect
                          placeholder=""
                          name="rs"
                          optionList={selectOptions.rs}
                          errors={errors.rs}
                          control={control}
                          isDisabled={rsDisable}
                          {...register("rs", {
                            onChange: (e) => {
                              UpdateFinalTable("RS :", e, 10, selectOptions.rs)
                              RemoveFinalTable("rs", e)
                              handleUpdateArray();
                            }
                          })}
                        />
                      </div>
                    </div>
                    <div class="col-md-4">
                      <div class="inputcu-field">
                        <label className="cu_form_label">
                          Special Lubricant :
                        </label>
                        <SearchableSelect
                          placeholder=""
                          name="specialLubricant"
                          optionList={selectOptions.specialLubricant}
                          errors={errors.specialLubricant}
                          control={control}
                          {...register("specialLubricant", {
                            onChange: (e) => {
                              UpdateFinalTable("Motor Side Oil seal :", e, 7, selectOptions.specialLubricant)
                              RemoveFinalTable("specialLubricant", e)
                              handleUpdateArray();
                            },
                            required: "Special Lubricant is required.",
                          })}
                        />
                      </div>
                    </div>
                    <div class="col-md-4">
                      <div class="input-group">
                        <label> Motor Side Oil seal :</label>
                        <input
                          type="text"
                          disabled={true}
                          id="motorSideOilSeal"
                          name="motorSideOilSeal"
                          placeholder={errors.motorSideOilSeal ? errors.motorSideOilSeal.message : ""}
                          className={errors.motorSideOilSeal ? "error" : ""}
                          {...register("motorSideOilSeal", {
                            // required: "Note is required.",
                            onChange: () => {
                              handleUpdateArray();
                            }
                          })}
                        />
                      </div>
                      {/* <div class="inputcu-field">
                        <label className="cu_form_label">
                          Motor Side Oil seal :
                        </label>
                        <SearchableSelect
                          placeholder=""
                          name="motorSideOilSeal"
                          optionList={selectOptions.motorSideOilSeal}
                          isDisabled={true}
                          errors={errors.motorSideOilSeal}
                          control={control}
                          {...register("motorSideOilSeal", {
                            // required: "Container Number is required.",
                          })}
                        />
                      </div> */}
                    </div>
                    <div class="col-md-4">
                      <div class="inputcu-field">
                        <label className="cu_form_label">IP :</label>
                        <SearchableSelect
                          placeholder=""
                          name="ip"
                          optionList={
                            getValues("vFan") ? selectOptions.ip.filter((opt) => opt.ipValue !== "65")
                              : selectOptions.ip
                          }
                          errors={errors.ip}
                          control={control}
                          {...register("ip", {
                            onChange: (e) => {
                              if (e.target.value === "65") {
                                UpdateFinalTable("IP :", e, 8, selectOptions.ip);
                                setVFanDisable(true);
                                setValue("vFan", "");
                              } else {
                                setVFanDisable(false);
                              }
                              RemoveFinalTable("ip", e)
                              handleUpdateArray();
                            }
                            // required: "Container Number is required.",
                          })}
                        />
                      </div>
                    </div>
                    <div class="col-md-4">
                      <div class="input-group">
                        <label>Motor(Optional) :</label>
                        <input
                          type="text"
                          id="motor_optional"
                          name="motor_optional"
                          placeholder={errors.motor_optional ? errors.motor_optional.message : ""}
                          className={errors.motor_optional ? "error" : ""}
                          {...register("motor_optional", {
                            // required: "Note is required.",
                            onChange: () => {
                              handleUpdateArray();
                            }
                          })}
                        />
                      </div>
                    </div>
                    <div class="col-md-4">
                      <div class="input-group">
                        <label>Motor Euro Price :</label>
                        <input
                          type="number"
                          min={0}
                          id="motor_europrice"
                          name="motor_europrice"
                          placeholder={errors.motor_europrice ? errors.motor_europrice.message : ""}
                          className={errors.motor_europrice ? "error" : ""}
                          {...register("motor_europrice", {
                            onBlur: (e) => {
                              UpdateFinalTable("Motor Optional ", e, 12, [])
                              RemoveFinalTable("motor_europrice", e)
                            },
                            onChange: () => {
                              handleUpdateArray();
                            }
                            // required: "Note is required.",
                          })}
                        />
                      </div>
                    </div>
                    <div class="col-md-4">
                      <div class="inputcu-field">
                        <label className="cu_form_label">
                          T.Box / Cable Entry :
                        </label>
                        <SearchableSelect
                          placeholder=""
                          name="tbCableEntry"
                          optionList={selectOptions.tbCableEntry}
                          errors={errors.tbCableEntry}
                          control={control}
                          {...register("tbCableEntry", {
                            required: "T.Box / Cable Entry is required.",
                            onChange: () => {
                              handleUpdateArray();
                            }
                          })}
                        />
                      </div>
                    </div>
                    <div className="line_box"></div>
                    <div class="col-md-4">
                      <div class="inputcu-field">
                        <label className="cu_form_label">Brake Voltage :</label>
                        <SearchableSelect
                          placeholder=""
                          name="brakeVoltage"
                          isDisabled={BreakSizeVal ? false : true}
                          optionList={selectOptions.brakeVoltage}
                          errors={errors.brakeVoltage}
                          control={control}
                          {...register("brakeVoltage", {
                            onChange: (e) => {
                              RemoveFinalTable("brakeVoltage", e)
                              handleUpdateArray();
                            },
                            required: BreakSizeVal ? "Fill Brake Voltage" : false,
                          })}
                        />
                      </div>
                    </div>
                    <div class="col-md-4">
                      <div class="inputcu-field">
                        <label className="cu_form_label">Brake Torque :</label>
                        <SearchableSelect
                          placeholder=""
                          name="breakTorque"
                          isDisabled={BreakSizeVal ? false : true}
                          optionList={selectOptions.breakTorque}
                          errors={errors.breakTorque}
                          control={control}
                          {...register("breakTorque", {
                            // onChange: (e) => {
                            //   UpdateFinalTable("RPM :", e, 1, selectOptions.breakTorque)
                            //   RemoveFinalTable("breakTorque", e)
                            // },
                            required: BreakSizeVal ? "Fill Brake Torque" : false,
                            onChange: () => {
                              handleUpdateArray();
                            }
                          })}
                        />
                      </div>
                    </div>
                    <div class="col-md-4">
                      <div class="inputcu-field">
                        <label className="cu_form_label">Brake Rectifier:</label>
                        <SearchableSelect
                          placeholder=""
                          name="break_rectifier"
                          isDisabled={BreakSizeVal ? false : true}
                          optionList={selectOptions.break_rectifier}
                          errors={errors.break_rectifier}
                          control={control}
                          {...register("break_rectifier", {
                            // onChange: (e) => {
                            //   UpdateFinalTable("RPM :", e, 1, selectOptions.break_rectifier)
                            //   RemoveFinalTable("break_rectifier", e)
                            // },
                            required: BreakSizeVal ? "Fill Brake Rectifier" : false,
                            onChange: () => {
                              handleUpdateArray();
                            }
                          })}
                        />
                      </div>

                      {/* <div class="input-group">
                        <label>Break Rectifier:</label>
                        <input
                          type="text"
                          id="break_rectifier"
                          name="break_rectifier"
                          placeholder={errors.break_rectifier ? errors.break_rectifier.message : ""}
                          className={errors.break_rectifier ? "error" : ""}
                          {...register("break_rectifier", {
                            // required: "Note is required.",
                          })}
                        />
                      </div> */}
                    </div>
                    <div class="col-md-4">
                      <div class="input-group">
                        <label>Output Shaft(mm) :</label>
                        <input
                          type="text"
                          id="output_shaft"
                          name="output_shaft"
                          placeholder={errors.output_shaft ? errors.output_shaft.message : ""}
                          className={errors.output_shaft ? "error" : ""}
                          {...register("output_shaft", {
                            // required: "Note is required.",
                            onChange: () => {
                              handleUpdateArray();
                            }
                          })}
                        />
                      </div>
                    </div>
                    <div class="col-md-4">
                      <div class="input-group">
                        <label>Output Flange(mm) :</label>
                        <input
                          type="text"
                          id="output_flange"
                          name="output_flange"
                          placeholder={errors.output_flange ? errors.output_flange.message : ""}
                          className={errors.output_flange ? "error" : ""}
                          {...register("output_flange", {
                            // required: "Note is required.",
                            onChange: () => {
                              handleUpdateArray();
                            }
                          })}
                        />
                      </div>
                    </div>
                    <div class="col-md-4">
                      <div class="input-group">
                        <label>MTG Position :</label>
                        <input
                          type="text"
                          id="mtg_position"
                          name="mtg_position"
                          placeholder={errors.mtg_position ? errors.mtg_position.message : ""}
                          className={errors.mtg_position ? "error" : ""}
                          {...register("mtg_position", {
                            // required: "Note is required.",
                            onChange: () => {
                              handleUpdateArray();
                            }
                          })}
                        />
                      </div>
                    </div>

                    <div class="col-md-4">
                      <div class="input-group">
                        <label>Spl. Insturction :</label>
                        <textarea
                          type="text"
                          id="special_instruction"
                          name="special_instruction"
                          placeholder={errors.special_instruction ? errors.special_instruction.message : ""}
                          className={errors.special_instruction ? "error" : ""}
                          {...register("special_instruction", {
                            // required: "Note is required.",
                            onChange: () => {
                              handleUpdateArray();
                            }
                          })}
                        />
                      </div>
                    </div>
                    <div class="col-md-4">
                      <div class="inputcu-field">
                        <label className="cu_form_label">2W :</label>
                        <SearchableSelect
                          placeholder=""
                          name="twoW"
                          optionList={selectOptions.twoW}
                          errors={errors.twoW}
                          control={control}
                          {...register("twoW", {
                            onChange: (e) => {
                              UpdateFinalTable("2W :", e, 13, selectOptions.twoW)
                              RemoveFinalTable("twoW", e)
                              handleUpdateArray();
                            },
                            // required: "Fill 2W",
                          })}
                        />
                      </div>
                      {from === "Topbar" && (
                        <div class="inputcu-field">
                          <label className="cu_form_label">Plant :</label>
                          <SearchableSelect
                            placeholder=""
                            name="plant"
                            optionList={plantArr}
                            errors={errors.plant}
                            control={control}
                            {...register("plant", {
                              // required:"Plant is required.",
                              onChange: () => {
                                handleUpdateArray();
                              }
                            })}
                          />
                        </div>
                      )}
                    </div>
                    <div class="col-md-4">
                      <div class="inputcu-field">
                        <label className="cu_form_label">C :</label>
                        <SearchableSelect
                          placeholder=""
                          name="c"
                          optionList={selectOptions.c}
                          errors={errors.c}
                          control={control}
                          {...register("c", {
                            onChange: (e) => {
                              UpdateFinalTable("C :", e, 14, selectOptions.c)
                              RemoveFinalTable("c", e)
                              handleUpdateArray();
                            },
                            // required: "Fill C",
                          })}
                        />
                      </div>
                      {from === "Topbar" && (
                        <div class="input-group">
                          <label>Part List Qty :</label>
                          <input
                            type="number"
                            min={1}
                            id="qty"
                            name="qty"
                            placeholder={errors.qty ? errors.qty.message : ""}
                            className={errors.qty ? "error" : ""}
                            {...register("qty", {
                              //  required: "Qty is required.",
                              onChange: () => {
                                handleUpdateArray();
                              }
                            })}
                          />
                        </div>
                      )}
                    </div>
                  </div>
                </div>

                <div className="col-md-4 DIBTable">
                  {FinalTableArray && FinalTableArray?.length > 0 &&
                    (
                      <table class="table table-bordered">
                        <thead>
                          <tr>
                            <th scope="col" class="hear_searial">
                              Parts Name
                            </th>
                            <th scope="col">Price</th>
                          </tr>
                        </thead>
                        <tbody>
                          {FinalTableArray.sort((a, b) => (a.index > b.index) ? 1 : -1).map((item) => (
                            <tr>
                              <td>{item?.name}</td>
                              <td class="DIBTableHeaderPrice">{item?.price}</td>
                            </tr>
                          ))}

                          <tr>
                            <td className="text-right"><strong>Total :</strong></td>
                            <td class="DIBTableHeaderPrice"><strong>{
                              FinalTableArray?.reduce((acc, value) => {
                                return (acc = acc + parseFloat(value.price));
                              }, 0).toFixed(2)}</strong></td>
                          </tr>


                        </tbody>
                      </table>
                    )}
                </div>



              </div>
            </div>
            :
            <div className="comanbox_body ">

              <div className="sibtable pt-3">
                <div className="row mx-0 g-4 DIBModel">
                  <div className="col-md-6">
                    <div className="tableParent DIBTable">
                      <table class="table table-bordered ">
                        <thead>
                          <tr>
                            <th scope="col" class="hear_searial">
                              Part Name
                            </th>
                            <th scope="col">Part Details</th>
                          </tr>
                        </thead>
                        <tbody>
                          {ResponseDataVal.map((item, index) => {
                            if (index <= 17) {
                              return (<tr>
                                <td className="title">{item?.partName}</td>
                                <td className="value" style={{
                                  whiteSpace: "nowrap",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  fontSize: item?.length > 30 ? "12px" : "14px"
                                }}
                                >{item?.partDetails}</td>
                              </tr>)
                            }
                          })}
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="tableParent DIBTable">
                      <table class="table table-bordered">
                        <thead>
                          <tr>
                            <th scope="col" class="hear_searial">
                              Part Name
                            </th>
                            <th scope="col">Part Details</th>
                          </tr>
                        </thead>
                        <tbody>
                          {ResponseDataVal.map((item, index) => {
                            if (index > 17) {
                              return (<tr>
                                <td className="title">{item?.partName}</td>
                                <td className="value" style={{
                                  whiteSpace: "nowrap",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  fontSize: item?.length > 30 ? "12px" : "14px"
                                }}
                                >{item?.partDetails}</td>
                              </tr>)
                            }
                          })}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>

              </div>
            </div>}
        </Modal.Body>
        <Modal.Footer>
          {viewForm ?
            <>
              <button
                class="Comnbtn OutlineRedBtn"
                onClick={() => { closeDIBModal(); setLoading([]) }}
              >
                Cancel
              </button>

              <button
                class="Comnbtn BlackBtn"
                disabled={loading.length}
                onClick={async () => {
                  const formValues = watch();
                  const updatedArray = Object.entries(formValues)?.map(([key, value]) => ({
                    fieldName: key,
                    value: value,
                  }));
                  setSelectedValues(updatedArray);
                  if (configureTag.length > 0) {
                    const isMatched = checkIfMatched(updatedArray, configureTag);
                    if (isMatched) {
                      await onSubmit(formValues, true);
                    } else {
                      errorToast("Configure tag match not found!", "error");
                    }
                  } else {
                    await onSubmit(formValues, true);
                    //   errorToast("Configure tag match not found!", "error");
                  }
                }}
              >
                {loading.includes(1) ? <ButtonLoader /> : "View Details"}
              </button>
              {/* {from === "Topbar" && (
                <button
                  class="Comnbtn BlackBtn"
                  disabled={loading.length}
                  onClick={handleSubmit(async (data) => await onSubmit(data, false))}
                >
                  {loading.includes(2) ? <ButtonLoader /> : "Part List"}
                </button>)} */}
            </>
            :
            <>
              <button
                class="Comnbtn OutlineRedBtn"
                onClick={() => setViewForm(true)}
              >
                <i class="fa fa-arrow-left" aria-hidden="true"></i> Back
              </button>
              {GetData &&
                <button
                  class="Comnbtn BlackBtn"
                  onClick={(e) => {
                    ResponseData(e, ResponseDataVal)
                    closeDIBModal()
                  }}
                >
                  {"Save"}
                </button>

              }
            </>
          }
        </Modal.Footer>
      </Modal >
    </>
  );
};

export default SelectDIBModal;
